import { Col, Form, Row } from 'antd'
import { t } from 'i18next'
import type { ReactElement } from 'react'

import { NodePropertyPicker } from '../common/NodePropertyPicker'
import type { NodeWithModel } from '../common/nodeWithModel'
import type { FilterFormItemState } from './common'
import { ViewFilterOptionFormItem } from './ViewFilterOptionFormItem'
import { ViewFilterTypeFormItem } from './ViewFilterTypeFormItem'
import { ViewFilterValueFormItem } from './ViewFilterValueFormItem'

export const ViewFilterFormItems = ({
  onChange,
  filter,
  propertiesWithNode,
  children,
}: {
  children: ReactElement
  filter: FilterFormItemState
  onChange: (x: FilterFormItemState, option?: { asInitialization?: boolean }) => void
  propertiesWithNode: NodeWithModel[]
}) => {
  // if (filter.type === 'field') {
  //   // 現状のロジックだとありえないはず
  //   return <></>
  // }

  const property =
    filter.property === undefined
      ? undefined
      : propertiesWithNode.find(
          (p) => p.model.name === filter.property?.modelName && p.property.name === filter.property.propertyName,
        )?.property
  // 条件セレクト(spans[2])は選択済み状態だとトリガー幅で ellipsis 切り詰めされる。複数選択項目の演算子ラベルは
  // 「次の要素を全て含む」/「次の要素を全ては含まない」のように肯定/否定の識別語が末尾寄りにあり、切り詰められると読み分けられない。
  // 24 グリッドは総和固定のため、値(spans[3])から 1 送って条件側を広げる。値セレクトは溢れを maxTagCount='responsive' で
  // 「+N」に畳むため、幅を減らしたときの劣化が条件セレクト(識別語の消失)より軽い。
  const spans = [property?.referenceTo === undefined ? 8 : 5, 3, 7, 9]

  return (
    <Row justify="space-between" align="middle">
      <Col span={23}>
        <Row justify="start" align="top" gutter={8}>
          <Col span={spans[0]}>
            <Form.Item label={t(`絞り込み項目`)} rules={[{ required: true, message: t(`入力してください`) }]}>
              <NodePropertyPicker
                propertiesWithNode={propertiesWithNode}
                picked={filter.property}
                onFinish={(property) => {
                  onChange({
                    // 大文字小文字の区別をデフォルトでONにする
                    // その他の値に対しては、不整合を防ぐため、propertyが変わったら全て削除する。
                    property,
                    option: { shouldConsiderCase: true },
                  })
                }}
              />
            </Form.Item>
          </Col>
          {property?.referenceTo !== undefined && (
            <Col span={spans[1]}>
              <ViewFilterOptionFormItem filter={filter} property={property} onChange={onChange} />
            </Col>
          )}
          <Col span={spans[2]}>
            <ViewFilterTypeFormItem filter={filter} property={property} onChange={onChange} />
          </Col>
          <Col span={spans[3]}>
            <ViewFilterValueFormItem filter={filter} property={property} onChange={onChange} />
          </Col>
        </Row>
      </Col>
      <Col span={1}>{children}</Col>
    </Row>
  )
}
